import { addDocument } from 'db/mutations';
import { getDocument } from 'db/queries';
import { getItem } from 'utils/localStorage';

export const matchReferrals = async (userId) => {
  const inviteCode = getItem('inviteCode');

  if (inviteCode) {
    const referredBy = await getDocument('handles', inviteCode);

    if (referredBy) {
      await addDocument('referrals', {
        referrerId: referredBy.uid,
        invitedId: userId,
        status: 'registered',
      });

      return referredBy.uid;
    }
  }

  return null;
};
